import storage from "./storage";

export const actualizeTitle = () => {
    const company = storage('session').get('company');
    document.getElementById('title').innerHTML = company.name + " Home - Talkr.ai"
}